import { SimpleCarousel } from '@eventbrite/collection-carousel';
import { FormattedEvent, ShareUTMOptions } from '@eventbrite/event-renderer';
import { LoadingSkeleton } from '@eventbrite/loading-skeleton';
import React from 'react';
import {
    COLLECTION_SURFACE_MAPPING,
    SEASONAL_HOLIDAY_FEATURED,
} from '../../../../../src/constants/seasonalFeatured';
import DiscoverVerticalEventCard from '../../../../components/DiscoverEventCard/DiscoverVerticalEventCard';
import { NIGHTLIFE_HOLIDAY_FEATURED } from '../../constants/analytics';
import { useBaseEventsQueryEvents } from '../../hooks/queries/events';
import './NightlifeCuratedContainer.scss';

interface HolidayFeaturedProps {
    holiday: string;
    isAuthenticated: boolean;
    isMobile: boolean;
    browseSurface: string;
    placeId: string;
}
interface TitleSection {
    holiday: string;
}

const shareOptions = {
    isMobile: false,
    twitterHandle: 'Eventbrite',
    serverUrl: 'https://www.evbdev.com',
    facebookOptions: {
        version: 'v2.8',
        xfbml: true,
        appId: '1433595320271557',
        locale: 'en_US',
        page: 'www.facebook.com/Eventbrite',
    },
};
const utmOptions: ShareUTMOptions = {
    'utm-campaign': 'social',
    'utm-content': 'attendeeshare',
    'utm-medium': 'discovery',
    'utm-term': '',
    'utm-source': '',
    'utm-share-source': 'category-browse',
};

const TitleDescription = React.memo(({ holiday }: TitleSection) => (
    <div className="title-subtitle-container">
        <h2>{SEASONAL_HOLIDAY_FEATURED[holiday].title}</h2>
        <h3>{SEASONAL_HOLIDAY_FEATURED[holiday].subTitle}</h3>
    </div>
));

export const HolidayFeatured = ({
    isAuthenticated,
    isMobile,
    holiday,
    placeId,
}: HolidayFeaturedProps) => {
    const collection = useBaseEventsQueryEvents({
        queryOverload: {
            collections_or: COLLECTION_SURFACE_MAPPING['Nightlife'],
            page_size: 8,
            places: [placeId],
            include_mature_events: true,
            include_manual_events: true,
            aggs: {},
            tags: [],
            start_hour_range: {
                start_hour: 0,
                end_hour: 24,
            },
            price: 'paid',
        },
        refetchOnMount: false,
        enabled: true,
        optOutDedupeEvents: true,
    });

    if (collection.isLoading) {
        return (
            <div className="nightlife-carousel-loading-state">
                <LoadingSkeleton
                    className="shimmer-effect loaderHeight"
                    height={isMobile ? '404px' : '443px'}
                />
            </div>
        );
    }

    if (
        !collection.data ||
        !collection.data?.events ||
        collection.data.events.length == 0
    )
        return null;

    const events: FormattedEvent[] =
        collection.data?.events.length != 0
            ? collection.data?.events || []
            : [];
    const showNavigation = events.length > 3;

    return (
        <div className="holiday-featured-events">
            <div className="holiday-featured-events-container">
                <TitleDescription holiday={holiday} />
                <div className="simple-carousel-parent">
                    <SimpleCarousel useSideNavigation={showNavigation}>
                        {events.map((event) => (
                            <div
                                className="holiday-featured-events-event-card"
                                key={event.id}
                            >
                                <DiscoverVerticalEventCard
                                    event={event}
                                    shareOptions={{
                                        ...shareOptions,
                                        utmOptions,
                                        trackingCategory: 'eventcard',
                                    }}
                                    isAuthenticated={isAuthenticated}
                                    affCode="ebdssbcategorybrowsecurated" //add affcode in prod
                                    isLazyImage={true}
                                    statsigLocationString={
                                        NIGHTLIFE_HOLIDAY_FEATURED
                                    }
                                    locale="en_US"
                                />
                            </div>
                        ))}
                    </SimpleCarousel>
                </div>
            </div>
        </div>
    );
};

export default HolidayFeatured;
